import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Layout from '../../../../app/Layout';
import Breadcrumb from '../../General/Breadcrumb';
import HeaderContent from '../../General/HeaderContent';
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading';
import ModalBasic from '../../../components/Modals/ModalBasic';
import FormularioModulo from '../../../components/ControlModulos/FormularioModulo';
import TabPublicacionWeb from '../../../components/ControlModulos/TabPublicacionWeb/TabPublicacionWeb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCog } from '@fortawesome/free-solid-svg-icons';
import useGetModulos from '../../../../hooks/useGetModulos';
import useModalBasic from '../../../../hooks/useModalBasic';
import './ModuloProyecto.scss';

const ModuloProyecto = () => {
  const { idModulo }         = useParams();
  const { modulos, loading } = useGetModulos();
  const { onCloseModal, onShowModal, showModal } = useModalBasic(false);
  const [modulo, setModulo] = useState(null);

  useEffect(() => {
    if (!loading && modulos.length > 0 && idModulo) {
      const encontrado = modulos.find(m => String(m.id_modulo) === String(idModulo));
      setModulo(encontrado || null);
    }
  }, [modulos, loading, idModulo]);

  // Muestra spinner mientras carga O mientras el store aún no tiene datos (estado inicial)
  if (loading || (!modulo && modulos.length === 0)) {
    return (
      <Layout>
        <SpinnerLoading loading={true} />
      </Layout>
    );
  }

  if (!modulo) {
    return (
      <Layout>
        <div className="alert alert-warning m-4">Sub-Producto no encontrado.</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="ModuloProyecto">
        <ModalBasic
          title="Editar Sub-Producto"
          show={showModal}
          updateShowModal={onCloseModal}
        >
          <FormularioModulo datosModulo={modulo} onCloseModal={onCloseModal} />
        </ModalBasic>

        <HeaderContent title={modulo.nombre_modulo || 'Sub-Producto'} icon="menu_book" />
        <Breadcrumb
          link={[
            { url: '/inicio',   nombre: 'Inicio',          icon: 'fas fa-home' },
            { url: '/modulos',  nombre: 'Sub-Productos' },
            { url: '#',         nombre: modulo.nombre_modulo || `#${idModulo}` },
          ]}
        />

        <div className="ModuloProyecto__body">
          <div className="box box-primary">
            <div className="box-header with-border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 className="mb-0" style={{ color: '#434343' }}>{modulo.nombre_modulo}</h5>
              <button className="btn btn-sm btn-outline-secondary" onClick={onShowModal}>
                <FontAwesomeIcon icon={faCog} className="mr-1" /> Editar datos
              </button>
            </div>
            <div className="box-body">
              <Tabs defaultActiveKey="publicacion" id="modulo-tabs">
                <Tab
                  eventKey="publicacion"
                  title={<span><FontAwesomeIcon icon={faGlobe} className="mr-1" />Publicación Web</span>}
                >
                  <TabPublicacionWeb
                    idModulo={parseInt(idModulo, 10)}
                    nombreModulo={modulo.nombre_modulo}
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ModuloProyecto;
